<template>
    <!-- 微信登陆 -->
    <div class='login'>
        <div class='head'>
            <img class='yl_logo' src="../../assets/images/yiliLogo.svg" alt="">
        </div>
        <div>
            <h1 class='logo'>{{config.title}}<span v-if='isDev'>测试环境</span></h1>
            <!-- 二维码 -->
            <div id="wechat" v-if='!codeShow'></div>
            <!-- 邀请码输入框 -->
            <div v-if='codeShow' style='margin-top:40px;'>
                <el-form class="form_box" :model="codeForm" status-icon :rules="rules" ref="codeForm">
                <el-form-item class='form_item' prop="code">
                    <el-input
                        minlength="3"
                        autosize
                        clearable
                        prefix-icon="font_family ds-icon-file-down"
                        maxlength="50"
                        v-model="codeForm.code"
                        autocomplete="off"
                        placeholder="请输入邀请码"
                    ></el-input>
                </el-form-item>
            </el-form>
            <el-button type="primary" class="btn" @click="binding" :loading='loading' :disabled="loading">{{loading?"绑定中...":"确认绑定"}}</el-button>
            </div>

        </div>
    </div>
</template>

<script>

    import config from "../config.js"    

    export default {
        data() {
            return {
                config,
                appId: config.appId,  // 正式
                // 微信登录script
                weixinScript: "//res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js",
                // 微信登录回调
                weixinCall: config.wxCall_url+"/security/wxPcCallBack?type="+config.projectType,
                
                openId: "",
                nickname: "",
                unionid: "",
                username: "",
                token: "",

                loading: false,
                codeForm: {
                    code: ""
                },
                rules: {
                    code: [{ required: true, message: "请输入邀请码", trigger: "blur" }]
                },
            }
        },
        computed: {
            codeShow() {
                return Boolean(this.openId);
            },
            isDev() {
                return process.env.NODE_ENV === "development"
            }
        },
        created() {
            let token = localStorage.getItem('token');
            if(token) this.$router.replace('/home');
            this.init();
        },
        methods: {
            init() {
                let code = this.$route.query.code;
                if (code == "400") {
                    this.$message({
                    message: "您的账号已过期，请联系管理员",
                    type: "warning"
                    });
                    return;
                }

                this.openId = this.$route.query.openid;
                this.nickname = this.$route.query.nickname;
                this.username = this.$route.query.username;
                this.token = this.$route.query.token;
                this.unionid = this.$route.query.unionid;

                if (this.token) {
                    //如果是扫码登录已经绑定账号，直接登录
                    localStorage.setItem('token',this.token);
                    localStorage.setItem('username',this.username);
                    this.loginSuccess()
                } else if (this.openId) {
                    //未绑定账号，提示绑定
                    this.$message({
                        message: "此账号还没有绑定过，请先输入邀请码绑定账号",
                        type: "warning"
                    });
                } else {
                    //生成二维码
                    this.getQRCode(); 
                }
            },
            //    生成登陆二维码
            getQRCode() {
                let self = this;
                let s = document.createElement("script");
                s.type = "text/javascript";
                s.src = this.weixinScript;
                let wxElement = document.body.appendChild(s);
                let url = this.weixinCall;
                wxElement.onload = function() {
                        let obj = new WxLogin({
                        id: "wechat",
                        appid: self.appId,
                        scope: "snsapi_login",
                        redirect_uri: encodeURIComponent(url),
                        state: Math.ceil(Math.random() * 1000),
                        // style: "white",
                        href: ""
                    });
                };
            },
            // 绑定邀请码
            binding() {
                // 表单验证
                if(this.codeForm.code == '') {
                    this.$refs.codeForm.validate();
                    return
                }
                this.loading = true;
                this.$http({
                    url: this.$api.binding+"?userCode="+this.codeForm.code+"&openid="+this.openId+"&nickname="+this.nickname+"&unionid="+this.unionid,
                }).then(res => {
                    this.loading = false;
                    if(res.code == 0) {
                        this.token = res.data.token;
                        this.username = res.data.username;
                        localStorage.setItem('token',this.token);
                        localStorage.setItem('username',this.username);
                        this.$message({
                            message: '账号绑定成功',
                            type: 'success'
                        });
                        setTimeout(() => {
                            this.loginSuccess();
                        },100)
                    }else {
                        if(res.code == 400) {
                            this.$message.error("无效的邀请码");
                        }else {
                            this.$message.error("绑定失败");
                        }
                    }
                })
                .catch(err => {
                    this.loading = false;
                    this.$message.error("绑定失败");
                });
            },
            // 登陆成功
            loginSuccess() {
                this.$router.replace('/home')
                this.$message({
                    message: '登录成功',
                    type: 'success'
                });
            },
        } 
    }
</script>

<style lang="scss" scoped>
@import "../../assets/css/common.scss";
#wechat {
  width: 300px;
  margin-top: 10px;
}


</style>


// WEBPACK FOOTER //
// src/pages/login/wxLogin.vue